import { useState, useEffect } from 'react'
import { getPositionAPI } from '../services/position'

function UsePositions(orgId, divisionId, departmentId, teamId) {
  const [data, setData] = useState([])
  useEffect(() => {
    const param = {
      orgId,
      divisionId,
      departmentId,
      teamId
    }
    const getData = async () => {
      const result = await getPositionAPI(param)
      if (!result) return

      const newData = result.result.map((d, i) => {
        return {
          value: d.id,
          label: d.position_en,
          label_th: d.position_th,
          level_id: d.level_id
        }
      })

      setData(newData)
    }
    if (orgId > 0 && divisionId > 0 && departmentId > 0 && teamId > 0) {
      getData()
    }
  }, [orgId, divisionId, departmentId, teamId])

  return data
}

export default UsePositions
